import { useRef } from "react";

// assets
import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";
import { SvgGoldBadge } from "assets/icons/js/SvgGoldBadge";

// customHooks
import useCheckEndsReached from "customHooks/useCheckEndsReached";
import { useMediaQuery } from "customHooks/useMediaQuery";

// helpers

// styles
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

export const ListingFeatured = ({ id, data }: any) => {
	const width = useMediaQuery();

	const breakpoint = 900;
	//check reaching ends of the list
	const listRef = useRef(null);
	const { reachedRight, reachedLeft } = useCheckEndsReached({ ref: listRef });

	const theme = useTheme();

	return (
		<div className="listing__featured__container">
			<div className="listing__featured__top">
				<span>
					<SvgGoldBadge />
					<h2>Featured</h2>
				</span>
				{/* {width > breakpoint && ( */}
				<div className="listing__spotlight-arrows">
					<span
						className="button-one"
						// @ts-ignore
						onClick={() => (listRef.current.scrollLeft += -595)}
					>
						{reachedLeft ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						)}
					</span>
					<span
						className="button-two"
						// @ts-ignore
						onClick={() => (listRef.current.scrollLeft += 590)}
					>
						{reachedRight ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						)}
					</span>
				</div>
				{/* )} */}
			</div>
			<div className="listing__featured__bottom" ref={listRef}>
				{data?.map((v: any) => {
					return (
						<div
							className="card"
							style={{
								borderColor: theme?.name === "xseries" ? "#B49F6B" : "",
							}}
							onClick={() => window.open(v.REFERENCE_URL, "_blank")}
						>
							<div className="image-container">
								<img
									src={
										"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/" +
										v.IMAGE_PATH +
										"?tr=q-60,f-webp"
									}
									alt=""
								/>
							</div>
							<div className="card__right">
								<span className="type">{v.NAME}</span>
								<div className="title" style={{ color: theme?.baseTextColor }}>
									{v.HEADING}
								</div>
								<div className="subtitle">{v.DESCRIPTION}</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};
